import UserProfile from "../Context/UserProfile";
import "./Blogs.css";
import { useEffect, useState } from "react";
const Blog1 = ({ setUserName,setPageTitle }) =>
{
    const [displayName, setDisplayName] = useState();
    useEffect(() => {
        setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
        if(UserProfile.getLoginStatus()==="1"){
			setPageTitle("The Cost of Unclear Agreements in Business");
		}
    }, []);
    return (
        <>
            <div className={displayName && displayName.length>0?"main-content":""}>
                {UserProfile.getLoginStatus()!=="1" && <><header>
						<div className="header-container">
							<div className="logo">
								<a style={{ textDecoration: "none" }} href="/">
									<span style={{ color: 'white' }}>Contr
										<span style={{ color: "#ff8400" }}>e</span>
										ct</span>
								</a>

							</div>
							<nav><a href="/Signup" className="btn btn-success">Sign In</a>
							</nav>
						</div>
					</header>
					<div style={{ paddingTop: '20px', paddingLeft: '20px' }}>
						<h1>The Cost of Unclear Agreements in Business</h1>
						<span className="effective-date">Last Updated: 3 December 2025</span>
					</div></>}
                <div className="blog-container">
                    <div>
                        <a href="/BlogList">Back to list</a>
                    </div>
                <div>

  <p>
    Many businesses operate without clear written contracts or rely on scattered communication across WhatsApp, 
    emails, and calls. Scope changes go undocumented, payment timelines remain unclear, and responsibilities 
    are loosely defined. When disputes arise, there is no single source of truth. This lack of structure leads 
    to delayed payments, broken trust, operational confusion, and increased legal risk.
  </p>

  <p>
    To manage this, businesses usually draft basic PDFs, exchange messages for approvals, and track invoices 
    separately in accounting tools. Remarks and attachments stay buried in chat threads. Execution updates 
    happen verbally. When disagreements occur, teams spend hours collecting screenshots, emails, and files 
    to reconstruct what was agreed and what was delivered.
  </p>

  <p>
    Contrect is an AI-powered agreement platform designed to bring structure to the entire contract lifecycle. 
    It assists users while drafting contracts, helps centralize review communication, and tracks execution 
    in one place. Instead of treating a contract as just a document, Contrect treats it as a live, trackable agreement.
  </p>

  <p>
    With Contrect, AI guides users through clear questions to draft professional agreements. 
    All remarks, revisions, and attachments remain linked to the contract. During execution, invoices raised, 
    payments made, and updates are recorded against the agreement. Businesses get reporting, status overviews, 
    and the ability to extract a complete contract record in a single PDF when needed.
  </p>

  <p>
    Clear agreements reduce disputes, improve accountability, and strengthen business relationships. 
    Contrect replaces scattered communication with structured documentation and execution tracking. 
    From drafting to reporting, everything stays connected. In business, clarity is protection—and structured 
    contracts are no longer optional.
  </p>

                    </div>

                </div>
            </div>
            
            
        </>
    );
};
export default Blog1;